import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@pella/cosmos-react';
import { QUERY_KEYS } from '../../utils/enums';

/**
 * Hook to fetch all MRO (Maintenance, Repair, and Operations) organizations.
 * @returns {object} MRO organizations query result with data, loading, success, and error states.
 */
export const useMROOrganizations = () => {
  const { api, apiReady } = useAPI();
  const { data, isLoading, isSuccess, isError, error } = useQuery({
    queryKey: [QUERY_KEYS.INV_MGMT_MRO_ORGANIZATIONS],
    queryFn: () =>
      api.orgManagement.getOrganizations({
        mro: 'Y',
      }),
    enabled: apiReady,
    staleTime: Number.POSITIVE_INFINITY,
  });
  return {
    mroOrgs: data,
    mroOrgsIsLoading: isLoading,
    mroOrgsIsSuccess: isSuccess,
    mroOrgsIsError: isError,
    mroOrgsError: error,
  };
};
